import React, { FC, ReactNode } from "react";
import { Row } from "react-bootstrap";
import Main from "./Main";
import Topbar from "./Topbar";
import SidebarContainer from "./Sidebar";
import FilterBar from "./FilterBar";

interface PrivateLayoutProps {
  children: ReactNode;
}

const PrivateLayout: FC<PrivateLayoutProps> = ({ children }) => {
  return (
    <>
      {/* <Row>
        <Topbar />
      </Row> */}
      {/* <div style={{ display: "flex", minHeight: "calc(100vh - 70px)" }}> */}
      {/* <SidebarContainer /> */}
      {children}
      {/* <Main></Main> */}
      {/* </div> */}
    </>
  );
};

export default PrivateLayout;
